import React from "react";
import styled, { css } from "styled-components";
import { ChevronDown } from "lucide-react";
import { IColumnDefinition, IItem } from "../types";

const TableCellClassName = "expand-column";

const Chevron = styled(ChevronDown)`
    transition: transform 150ms;
`;

const CollapseButton = styled.button<{ $open: boolean }>`
    width: 100%;
    border: none;
    background: transparent;
    padding: 0;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    cursor: pointer;

    ${({ $open }) =>
        $open &&
        css`
            ${Chevron} {
                transform: rotate3d(1, 0, 0, 180deg);
            }
        `}
`;

export const ExpandTableCellStyle = css`
    &.${TableCellClassName} {
        position: relative;

        ${CollapseButton} {
            ::after {
                content: "";
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
            }
        }
    }
`;

const expandColumn: IColumnDefinition<IItem, "expand"> = {
    id: "expand",
    size: 30,
    maxSize: 30,
    minSize: 30,
    cell: ({ row }) => (
        <CollapseButton
            type="button"
            onClick={e => {
                e.stopPropagation();
                row.toggleExpanded();
            }}
            $open={row.getIsExpanded()}
        >
            <Chevron size={20} />
        </CollapseButton>
    ),
    meta: {
        actions: true,
        cellClassName: TableCellClassName,
        headerClassName: TableCellClassName
    }
};

export default expandColumn;
